const selectors = {
    nav: '#navbar',
    navWrapper: '#navbar_wrapper',
    burger: '#navbar_burger',
    link: '#navbar_links_wrapper .links__item .link',
    linksWrapper: '#navbar_links_wrapper',
    logo: '#rotating_logo',
    hcpNav: '.js-hcp-nav'
};

const classes = {
    transparent: 'is-transparent'
}

const dom = {};

const init = () => {
    dom.navbarWrapperHTMLElement = document.querySelector(selectors.navWrapper);
    if (!dom.navbarWrapperHTMLElement) return;
    dom.navbarWrapperOffsetTop = dom.navbarWrapperHTMLElement.offsetTop ?? 0;
    dom.navbarElement = dom.navbarWrapperHTMLElement.querySelector(selectors.nav);
    if (!dom.navbarElement) return;
    dom.navbarBurgerElement = dom.navbarElement.querySelector(selectors.burger);
    dom.nabvarLinksWrapperElement = dom.navbarElement.querySelector(selectors.linksWrapper);
    dom.navbarLinks = dom.navbarElement.querySelectorAll(selectors.link);
    dom.logo = document.querySelector(selectors.logo);
    dom.hcpNav = document.querySelector(selectors.hcpNav);

    initNavbarTransparent();
    initNavbarMenuMobile();
};

const initNavbarTransparent = () => {
    updateNavbarOnScroll();
    window.addEventListener('scroll', updateNavbarOnScroll);
}

const initNavbarMenuMobile = () => {
    if (!dom.navbarBurgerElement || !dom.nabvarLinksWrapperElement) return;

    dom.navbarBurgerElement.addEventListener('click', e => {
        e.preventDefault();

        if (dom.nabvarLinksWrapperElement.classList.contains('navbar__links-wrapper--active')) {
            document.body.classList.remove('body--no-scroll-y');
            dom.navbarWrapperHTMLElement.classList.remove('navbar-wrapper--active');
            dom.navbarElement.classList.remove('navbar--active');
            dom.navbarBurgerElement.classList.remove('navbar__burger--active');
            dom.nabvarLinksWrapperElement.classList.remove('navbar__links-wrapper--active');
        } else {
            document.body.classList.add('body--no-scroll-y');
            dom.navbarWrapperHTMLElement.classList.add('navbar-wrapper--active');
            dom.navbarElement.classList.add('navbar--active');
            dom.navbarBurgerElement.classList.add('navbar__burger--active');
            dom.nabvarLinksWrapperElement.classList.add('navbar__links-wrapper--active');
        }
    });

    if (dom.navbarLinks) {
        dom.navbarLinks.forEach((navbarLink) => {
            navbarLink.addEventListener('click', e => {
                const subLinksWrapper = navbarLink.parentElement.querySelector('.item__sub-links');

                if (subLinksWrapper) {
                    e.preventDefault();

                    subLinksWrapper.classList.toggle('item__sub-links--active');
                }
            });
        });
    }
}

const updateNavbarOnScroll = () => {
    if (document.body.classList.contains('body--navbar-overlap')) {
        if (window.scrollY <= dom.navbarWrapperOffsetTop + 16) {
            dom.navbarWrapperHTMLElement.classList.add('navbar-wrapper--transparent');
            dom.navbarElement.classList.add('navbar--transparent');
            if (dom.hcpNav) {
                dom.hcpNav.classList.add(classes.transparent);
            }
        } else {
            dom.navbarWrapperHTMLElement.classList.remove('navbar-wrapper--transparent');
            dom.navbarElement.classList.remove('navbar--transparent');
            if (dom.hcpNav) {
                dom.hcpNav.classList.remove(classes.transparent);
            }
        }
    }

    dom.logo.style.transform = `rotate(${window.pageYOffset / 5}deg)`;
}

const module = () => {
    init();
};

export default module;